import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'
import { reatomAsyncState } from '@root/shared/lib'

import type { DelugeId } from '@root/entities/user-short'

interface BackOfficeUserChangeActivityRequestData {
  delugeId: DelugeId
  action: 'block' | 'unblock'
}

export const reatomBackOfficeUserChangeActivityRequestAction = action(
  async (ctx, data: BackOfficeUserChangeActivityRequestData) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.admin.adminUsersBlockCreate, [
        {
          delugeIds: [data.delugeId],
          blocked: data.action === 'block',
        },
      ]),
    )

    return result.pipe(
      Result.map((it) => ({
        success: it.success,
      })),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'reatomBackOfficeUserChangeActivityRequestAction',
)

reatomAsyncState
